import { useEffect } from 'react';

// Adds `is-in` to every `.r-reveal` element as it scrolls into view.
// Mirrors the design handoff's IntersectionObserver reveal.
const useReveal = (deps = []) => {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll('.r-reveal:not(.is-in)'));
    if (!els.length) return undefined;

    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return undefined;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '-40px 0px' }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useReveal;
